import React, { useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { formatEventStartTime } from '@xanadu/ui-shared/utils/dates';
import Highlighted from '@xanadu/ui-shared/components/common/Highlighted';

import styles from './SearchItem.module.scss';

const SearchItem = ({
  result,
  query,
  onNavigate
}) => {
  const itemEl = useRef();

  const {
    dateStr,
    timeStr
  } = formatEventStartTime(new Date(result.startTime));

  const url = `/events/${result.id}`;

  const competition = result.metaTags
    .find(({ type }) => ['COMPETITION', 'LOCATION'].includes(type)) || {};

  const participantName = result.participants
    // this check is necessary as the backend currently may return an "null" item
    .find(participant => participant && participant.includes(query));

  const handleNavigate = () => {
    onNavigate(url);
  };

  const handleKeydown = useCallback((e) => {
    const enterPressed = e.key === 'Enter';

    if (enterPressed) {
      handleNavigate(url);
    }
  }, [url]);

  useEffect(() => {
    if (itemEl.current) {
      itemEl.current.addEventListener('keydown', handleKeydown);
    }

    return () => {
      if (itemEl.current) {
        itemEl.current.removeEventListener('keydown', handleKeydown);
      }
    };
  }, []);

  let mainName = result.name;
  let competitionName = competition.name;

  if (!result.name.includes(query) && participantName) {
    mainName = participantName;
    competitionName = result.name;
  }

  return (
    <div
      role="button"
      tabIndex="0"
      ref={itemEl}
      className={styles.main}
      onMouseDown={handleNavigate}
      data-hook={`search-result-${result.id}`}
    >
      <div>
        <span className={styles.icon}>
          <img
            src={`/assets/images/icons/icon-sport-svg/${result.sport}.svg`}
            alt={result.sport}
          />
        </span>
        <span className={styles.name}>
          <Highlighted
            text={mainName}
            highlight={query}
          />
          <span className={styles.competitionName}>{competitionName}</span>
          <span className={styles.dateMobile}>
            {dateStr} {timeStr}
          </span>
        </span>
      </div>
      <div>
        <span className={styles.resultItemDate}>
          {dateStr} {timeStr}
        </span>
      </div>
    </div>
  );
};

SearchItem.propTypes = {
  result: PropTypes.object.isRequired,
  query: PropTypes.string.isRequired,
  onNavigate: PropTypes.func.isRequired
};

export default SearchItem;
